import React from 'react';
import { Route } from 'react-router-dom';
import EventsSearchPageRoute from './EventsSearchPageRoute';

const basePath = '/v2/events';

export default (
  <Route path={basePath}>
    <Route exact path={basePath}>
      <EventsSearchPageRoute />
    </Route>
  </Route>
);
